/**
 * Gets a URL param and removes it
 */
export function consumeUrlParam(param: string): string | undefined {
    const paramValue = new URLSearchParams(window.location.search).get(param);
    if (paramValue === null) return;
    const url = new URL(window.location.href);
    url.searchParams.delete(param);
    window.history.replaceState({}, "", url.toString());
    return paramValue;
}

/**
 * Gets a URL param
 */
export function getUrlParam(param: string): string | null {
    return new URLSearchParams(window.location.search).get(param);
}
